import { createAction } from 'typesafe-actions';
import type { Step } from './types';

export const PDP_REVIEW_FORM_STEP_CHANGED = createAction('ui/PDP_REVIEW_FORM_STEP_CHANGED')<{
  newStep: Step;
  newStepRuName: string;
}>();

export const PDP_REVIEW_FORM_PUBLICATION_ERROR_SHOWN = createAction(
  'ui/PDP_REVIEW_FORM_PUBLICATION_ERROR_SHOWN',
)<{ ruText: string }>();

export const BODY_FIELD_FOCUSED = createAction('ui/PDP_REVIEW_FORM_BODY_FIELD_FOCUSED')();

export const PROS_FIELD_FOCUSED = createAction('ui/PDP_REVIEW_FORM_PROS_FIELD_FOCUSED')();

export const CONS_FIELD_FOCUSED = createAction('ui/PDP_REVIEW_FORM_CONS_FIELD_FOCUSED')();

export const PHOTO_SELECTION_CLICK = createAction('ui/PDP_REVIEW_FORM_PHOTO_SELECTION_CLICK')();

export const AUTHOR_SHOP_SELECTED = createAction('ui/PDP_REVIEW_FORM_AUTHOR_SHOP_SELECTED')<{
  shopName: string;
}>();

export const AUTHOR_REGION_SELECTED = createAction('ui/PDP_REVIEW_FORM_AUTHOR_REGION_SELECTED')<{
  regionName: string;
}>();
